import { useState, useEffect } from "react";
import Loader from "../../../Components/Loader";
import { Modal } from "../../../Components/Modal";
import { AdminIcon } from "../../../Icons/AdminIcon";
import { GroupDto } from "../../../Types/GroupServiceTypes";
import { SeminarDto, CreateSeminarDto } from "../../../Types/SeminarServiceTypes";
import '../AdminGroups.css'
interface Props {
  /** om seminar = undefined → CREATE MODE */
  seminar?: SeminarDto | null;

  /** alla grupper att lista i checkboxar */
  groups: GroupDto[];

  /** stänger modalen */
  onClose: () => void;

  /** callback med payload */
  //onSubmit: (dto: CreateSeminarDto) => Promise<void>;
onSubmit: (dto: CreateSeminarDto, options?: { sendInvites?: boolean }) => Promise<void>;
  /** sätter loader */
  isSaving: boolean;
}

const CreateOrEditSeminarModal: React.FC<Props> = ({
  seminar,
  groups,
  onClose,
  onSubmit,
  isSaving
}) => {
  const [form, setForm] = useState<CreateSeminarDto>({
    title: "",
    description: "",
    date: "",
    time: "",
    link: "",
    selectedGroups: []
  });
  const selectedGroupCount = form.selectedGroups.length;

  useEffect(() => {
    if (seminar) {
      setForm({
        title: seminar.title,
        description: seminar.description ?? "",
        date: seminar.date ?? "",
        time: seminar.time ?? "",
        link: seminar.link ?? "",
        selectedGroups: seminar.groups.map(g => g.groupId)
      });
    }
  }, [seminar]);

  const handleSubmit = async () => {
    if (!form.title || !form.link || form.selectedGroups.length === 0) return;
    await onSubmit(form);
  };

  const toggleGroup = (id: string) => {
    setForm(prev => {
      const selected = prev.selectedGroups.includes(id)
        ? prev.selectedGroups.filter(x => x !== id)
        : [...prev.selectedGroups, id];
      return { ...prev, selectedGroups: selected };
    });
  };

  return (
    <Modal className="admin-group-modal-layout" onClose={onClose}>
      <div className="admin-group-modal-close">
        <button type="button" aria-label="Stäng" onClick={onClose}>
          <AdminIcon.CrossClose fill="hsl(var(--primary))" width={18} />
        </button>
      </div>

      <div className="sheet-header-container">
        <h2 className="sheet-header-text">
          {seminar ? "Redigera seminarium" : "Skapa seminarium"}
        </h2>
        <p className="sheet-header-paragraph">
          Fyll i information och välj vilka grupper som ska bjudas in.
        </p>
        <div className="admin-group-modal-hero-row">
          <p className="admin-group-modal-help-text">{selectedGroupCount} grupper valda</p>
          <p className="admin-group-modal-help-text">{form.title ? 'Titel satt' : 'Titel saknas'}</p>
        </div>
      </div>

      <div className="admin-group-modal-form admin-group-modal-grid">
        {/* Titel */}
        <label className="block-text-sm-font-medium-text-gray-700-mb-1">
          Seminartitel *
        </label>
        <input
          className="admingroups-input"
          value={form.title}
          onChange={e => setForm(prev => ({ ...prev, title: e.target.value }))}
        />

        {/* Länk */}
        <label className="block-text-sm-font-medium-text-gray-700-mb-1">
          Länk (Zoom, Teams...) *
        </label>
        <input
          className="admingroups-input"
          value={form.link}
          onChange={e => setForm(prev => ({ ...prev, link: e.target.value }))}
        />

        {/* Datum */}
        <label className="block-text-sm-font-medium-text-gray-700-mb-1">
          Datum
        </label>
        <input
          type="date"
          className="admingroups-schedule--time-input"
          value={form.date}
          onChange={e => setForm(prev => ({ ...prev, date: e.target.value }))}
        />

        {/* Tid */}
        <label className="block-text-sm-font-medium-text-gray-700-mb-1">
          Tid
        </label>
        <input
          type="time"
          className="admingroups-schedule--time-input"
          value={form.time}
          onChange={e => setForm(prev => ({ ...prev, time: e.target.value }))}
        />

        {/* Beskrivning */}
        <label className="block-text-sm-font-medium-text-gray-700-mb-1">
          Beskrivning
        </label>
        <textarea
          className="admingroups-input"
          rows={4}
          value={form.description}
          onChange={e =>
            setForm(prev => ({ ...prev, description: e.target.value }))
          }
        />

        {/* Grupper */}
        <label className="block-text-sm-font-medium-text-gray-700-mb-2">
          Välj grupper att bjuda in *
        </label>
        <div className="space-y-2">
          {groups.map(g => (
            <label key={g.id} className="flex-items-center-space-x-3">
              <input
                type="checkbox"
                checked={form.selectedGroups.includes(g.id)}
                onChange={() => toggleGroup(g.id)}
                className="rounded-border-gray-300-text-e16a54-focus-ring-e16a54"
              />
              <span className="text-sm">
                {g.name} ({g.users.length} medlemmar)
              </span>
            </label>
          ))}
        </div>
      </div>

      {/* Submit-knapp */}
      <div className="admin-group-modal-footer admin-group-modal-footer--stack" style={{ justifyContent: "space-between", gap: "0.75rem", flexWrap: "wrap" }}>
        <button
          type="submit"
          className="sheet-form-submit-button"
          onClick={handleSubmit}
          disabled={isSaving || !form.title || !form.link || form.selectedGroups.length === 0}
        >
          {isSaving ? (
            <>
              <Loader loaderSize="SMALL" bgColor="white" /> Sparar...
            </>
          ) : seminar ? (
            <>
              <AdminIcon.Save width={16} height={16} fill="white" /> Spara ändringar
            </>
          ) : (
            <>
              <AdminIcon.PlusSign width={16} height={16} fill="white" /> Skapa seminarium
            </>
          )}
        </button>
        {seminar && (
          <button
            type="button"
            className="sheet-form-submit-button"
            style={{ width: "auto" }}
            onClick={() => onSubmit(form, { sendInvites: true })}
            disabled={isSaving || !form.title || !form.link || form.selectedGroups.length === 0}
          >
            {isSaving ? (
              <>
                <Loader loaderSize="SMALL" bgColor="white" /> Skickar...
              </>
            ) : (
              <>
                <AdminIcon.Mail width={16} height={16} fill="white" />
                Spara & skicka inbjudningar
              </>
            )}
          </button>
        )}
      </div>
    </Modal>
  );
};

export default CreateOrEditSeminarModal;
